import React, { useEffect } from 'react';
import Button from './Button';

interface DrawerProps {
  open: boolean;
  onClose?: () => void;
  title?: string;
  footer?: React.ReactNode;
  children: React.ReactNode;
  closeOnBackdrop?: boolean;
}

export default function Drawer({ open, onClose, title, footer, children, closeOnBackdrop = true }: DrawerProps) {
  useEffect(() => {
    if (!open) return;
    const handler = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose?.(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="t-drawer-backdrop" onClick={closeOnBackdrop ? onClose : undefined}>
      <div className="t-drawer" onClick={e => e.stopPropagation()} role="dialog" aria-modal="true">
        {title && (
          <div className="t-drawer-head">
            <h2>{title}</h2>
            <Button kind="ghost" size="sm" icon="x" iconOnly aria-label="Close" onClick={onClose} />
          </div>
        )}
        <div className="t-drawer-body">{children}</div>
        {footer && <div className="t-drawer-foot">{footer}</div>}
      </div>
    </div>
  );
}
